import { QRCodeSVG } from "qrcode.react";
import ModalGeneric from "./ModalGeneric";
import Countdown from "./CountDown";

/* eslint-disable react/prop-types */
function CheckoutQR({ activeModal, setActiveModal, cleanCart, navigate }) {
    return (
        <ModalGeneric
            isVisible={activeModal.isVisible}
            onClose={() => setActiveModal({ isVisible: false })}
        >
            <div className="flex flex-col justify-center items-center p-4">
                <h3 className="my-4 text-center text-xl">
                    Escanea con tu billetera de preferencia
                </h3>
                <Countdown initialSeconds={900} />
                <QRCodeSVG
                    value={activeModal.qr_code}
                    size={256}
                    className="my-5"
                />
                <p className="text-red-600 font-mono text-center font-bold uppercase ">
                    No pagar despues de los 15 minutos. Generar nuevo qr
                </p>
                <button
                    className="bg-zinc-900 hover:bg-zinc-500 text-zinc-200 py-3 px-4 rounded-lg mt-4 w-full "
                    onClick={() => {
                        window.location.href = activeModal.url;
                    }}
                >
                    Mas opciones de pago
                </button>
                <button
                    className="bg-yellow-cdg hover:bg-yellow-300 text-black py-3 px-4 rounded-lg mt-8 w-full "
                    onClick={() => {
                        cleanCart();
                        navigate("/tickets");
                    }}
                >
                    Ya pague!
                </button>
            </div>
        </ModalGeneric>
    );
}

export default CheckoutQR;
